import React, { useRef, useMemo, useEffect } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

function SuperBrightStars({ setBrightStars }) {
  const starsRef = useRef();
  const brightStarsRef = useRef([]);

  // 🌟 **Generování superjasných hvězd**
  const brightStars = useMemo(() => {
    const starsArray = [];
    const minDistance = 2000; // 🔥 Hvězdy blíž pro lepší viditelnost
    const maxDistance = 3000;

    for (let i = 0; i < 3; i++) {
      const distance = THREE.MathUtils.randFloat(minDistance, maxDistance);
      const angle1 = Math.random() * Math.PI * 2;
      const angle2 = Math.acos((Math.random() * 2) - 1);

      const position = new THREE.Vector3(
        distance * Math.sin(angle2) * Math.cos(angle1),
        distance * Math.sin(angle2) * Math.sin(angle1),
        distance * Math.cos(angle2)
      );

      const size = THREE.MathUtils.randFloat(4, 8); // 🔥 O něco větší hvězdy
      const color = new THREE.Color(`hsl(${Math.random() * 360}, 100%, 90%)`);
      const emissiveIntensity = THREE.MathUtils.randFloat(5, 15); // 🔥 Různá svítivost

      starsArray.push({ position, size, color, emissiveIntensity });
    }

    return starsArray;
  }, []);

  // 🔗 **Předání referencí do `setBrightStars`**
  useEffect(() => {
    if (setBrightStars) {
      setBrightStars(brightStarsRef.current.filter(Boolean));
    }
  }, [setBrightStars]);

  useFrame(() => {
    if (starsRef.current) {
      starsRef.current.rotation.y += 0.00005;
    }
  });

  return (
    <group ref={starsRef}>
      {brightStars.map((star, i) => (
        <mesh
          key={i}
          ref={(el) => (brightStarsRef.current[i] = el)}
          position={star.position}
        >
          <sphereGeometry args={[star.size, 16, 16]} />
          <meshStandardMaterial
            color={star.color}
            emissive={star.color}
            emissiveIntensity={star.emissiveIntensity}
            toneMapped={false} // 🔥 Zajištění správné svítivosti
          />
        </mesh>
      ))}
    </group>
  );
}

export default SuperBrightStars;